// Dashboard.js
import React, { useContext, useState } from "react";
import { Box } from "@mui/material";
import { AuthContext } from "../contexts/AuthContext";
import DashboardSidebar from "./DashboardSidebar";
import DashboardContent from "./DashboardContent";

const Dashboard = () => {
  const { user } = useContext(AuthContext);
  const [selectedFeature, setSelectedFeature] = useState("Home");

  if (!user) {
    return <p>Loading...</p>;
  }

  const handleSelectFeature = (feature) => {
    setSelectedFeature(feature);
  };

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      {/* Sidebar */}
      <DashboardSidebar
        selectedFeature={selectedFeature}
        onSelectFeature={handleSelectFeature} // Pass the function properly
        user={user} // Pass user info for the sidebar
      />

      {/* Main Content */}
      <Box
        component="main"
        sx={{ flexGrow: 1, bgcolor: "background.default", p: 3 }}
      >
        <DashboardContent selectedFeature={selectedFeature} />
      </Box>
    </Box>
  );
};

export default Dashboard;
